import React, {useState} from 'react';
import {useDashboard} from './context';
import {solutionList} from './scoring';
import {updatedStamp} from '../../lib/time';

/** JTBD distribution across the ERTO phases, by service area. Ported verbatim from the prototype. */
export function KanbanView(): React.ReactElement {
  const {phases, phaseColors, serviceAreas, domains} = useDashboard();
  const [activeServiceArea, setActiveServiceArea] = useState(serviceAreas[0]?.id || '');

  const saDomains = domains.filter(d => d.area === activeServiceArea);

  const phaseTotals: Record<string, number> = phases.reduce((acc, p) => {
    acc[p] = saDomains.reduce((s, d) => s + d.jtbds.filter(j => j.phase === p).length, 0);
    return acc;
  }, {} as Record<string, number>);

  return (
    <div>
      <div style={{marginBottom: 20}}>
        <h2 style={{fontSize: 20, fontWeight: 700, color: '#0F172A', letterSpacing: '-0.02em', marginBottom: 4}}>
          Transformation Kanban
        </h2>
        <p style={{fontSize: 13, color: '#64748B'}}>JTBD distribution across transformation phases by service area</p>
      </div>

      {/* SA tabs */}
      <div style={{display: 'flex', gap: 8, marginBottom: 24, borderBottom: '1px solid #E2E8F0', paddingBottom: 0}}>
        {serviceAreas.map(a => (
          <button
            key={a.id}
            onClick={() => setActiveServiceArea(a.id)}
            style={{
              padding: '8px 16px',
              fontSize: 12,
              fontWeight: 600,
              background: activeServiceArea === a.id ? '#fff' : 'transparent',
              border: '1px solid ' + (activeServiceArea === a.id ? '#E2E8F0' : 'transparent'),
              borderBottom: activeServiceArea === a.id ? '1px solid #fff' : '1px solid #E2E8F0',
              marginBottom: activeServiceArea === a.id ? -1 : 0,
              borderRadius: '8px 8px 0 0',
              color: activeServiceArea === a.id ? a.color : '#94A3B8',
              cursor: 'pointer'
            }}
          >
            {a.id}
          </button>
        ))}
      </div>

      {/* Board */}
      <div style={{display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: 12}}>
        {phases.map(phase => {
          const phaseJtbds = saDomains.flatMap(d => d.jtbds.filter(j => j.phase === phase).map(j => ({...j, domainName: d.name})));
          const colors = phaseColors[phase] || {pill: '#F1F5F9', text: '#64748B', border: '#E2E8F0'};
          return (
            <div key={phase}>
              <div
                style={{
                  padding: '8px 10px',
                  background: colors.pill,
                  borderRadius: '8px 8px 0 0',
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                  border: `1px solid ${colors.border}`,
                  borderBottom: 'none'
                }}
              >
                <span style={{fontSize: 11, fontWeight: 700, color: colors.text, textTransform: 'uppercase', letterSpacing: '0.06em'}}>
                  {phase}
                </span>
                <span style={{fontSize: 11, fontWeight: 700, color: colors.text, fontFamily: "'DM Mono', monospace"}}>
                  {phaseTotals[phase]}
                </span>
              </div>
              <div
                style={{
                  border: `1px solid ${colors.border}`,
                  borderTop: 'none',
                  borderRadius: '0 0 8px 8px',
                  minHeight: 200,
                  padding: 8,
                  background: '#fafcff',
                  display: 'flex',
                  flexDirection: 'column',
                  gap: 6
                }}
              >
                {phaseJtbds.map((j, i) => {
                  const updatedLabel = updatedStamp(j.lastUpdated);
                  const sols = solutionList(j);
                  return (
                    <div key={i} style={{background: '#fff', border: '1px solid #E2E8F0', borderRadius: 6, padding: '8px 10px'}}>
                      <div style={{fontSize: 11, fontWeight: 500, color: '#0F172A', lineHeight: 1.4, marginBottom: 4}}>{j.name}</div>
                      <div style={{fontSize: 10, color: '#94A3B8'}}>{j.domainName}</div>
                      {sols.length > 0 && (
                        <div style={{display: 'flex', gap: 4, flexWrap: 'wrap', marginTop: 5}}>
                          {sols.map(s => (
                            <span key={s} style={{fontSize: 9, padding: '1px 5px', background: '#F1F5F9', borderRadius: 3, color: '#64748B'}}>
                              {s}
                            </span>
                          ))}
                        </div>
                      )}
                      <div style={{fontSize: 9, color: '#94A3B8', marginTop: 4, fontFamily: "'DM Mono', monospace"}}>{updatedLabel}</div>
                    </div>
                  );
                })}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
